import Cookies from 'js-cookie';
import dynamic from 'next/dynamic';

import useLoggedUser from '../../../hooks/use-logged-user';
import { ADVANCED_VIEW_ACTIVE } from '../../../static/cookies';
import { useAppContext } from '../../providers/app-context';
import { useState, useEffect } from 'react';

const Default = dynamic(() => import('./default'), { ssr: false });
const Checkout = dynamic(() => import('./checkout-header'), { ssr: false });
const ProSBHeader = dynamic(() => import('./pro-sb-header'), { ssr: false });

const ProIntroHeader = dynamic(() => import('./pro-intro-header'), { ssr: false });

const Header = ({ type, defaultProps }: THeader) => {
  const [mounted, setMounted] = useState(false);
  const user = useLoggedUser();
  const { tenantConfig } = useAppContext();

  useEffect(() => {
    setMounted(true);
  }, []);

  const isAdvanced = mounted ? user?.staff?.is_pro : false;

  if (!mounted) {
    return <div className='relative !h-12 w-full z-200 bg-white'></div>
  }

  if (tenantConfig && tenantConfig.id === 5) {
    return <ProSBHeader type='SERVICE-BOX' />
  }

  // Bypass explicit PRO Intro header before hijacking the layout
  if (type === 'PRO-INTRO') {
    return <ProIntroHeader />;
  }

  if (isAdvanced && tenantConfig?.id !== 5) {
    return <ProSBHeader type='ADVANCED-SEARCH' />
  }

  switch (type) {
    case 'NONE':
      return null;
    case 'PRO-INTRO':
      return <ProIntroHeader />
    case 'ADVANCED-SEARCH':
      return <ProSBHeader type='ADVANCED-SEARCH' />
    case 'SERVICE-BOX':
      return <ProSBHeader type='SERVICE-BOX' />
    case 'CHECKOUT':
      return <Checkout />
    case 'DEFAULT':
    default:
      return <Default {...defaultProps} />
  }
};

export default Header;
